module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "jjgk"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    class: {
      active: _vm.tabindex === 0
    },
    on: {
      "click": function($event) {
        _vm.tabindex = 0
      }
    }
  }, [_vm._v("概况")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabindex === 1
    },
    on: {
      "click": function($event) {
        _vm.tabindex = 1
      }
    }
  }, [_vm._v("信息")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabindex === 2
    },
    on: {
      "click": function($event) {
        _vm.tabindex = 2
      }
    }
  }, [_vm._v("投资经理")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabindex === 0),
      expression: "tabindex===0"
    }]
  }, [(_vm.jjgk) ? _c('div', {
    staticClass: "wapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "i"
  }, [_vm._v("i")]), _vm._v("\n        " + _vm._s(_vm.jjgk.xx.name) + "\n      ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rz"
  }, [_vm._v("基金类型：" + _vm._s(_vm.jjgk.xx.jjlx))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金风格：" + _vm._s(_vm.jjgk.xx.jjfg))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("单位净值：" + _vm._s(_vm.jjgk.gk[_vm.jjgk.gk.length - 1].dwjz))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("累计净值：" + _vm._s(_vm.jjgk.gk[_vm.jjgk.gk.length - 1].ljjz))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("累计年化：" + _vm._s(parseFloat(_vm.jjgk.gk[_vm.jjgk.gk.length - 1].ljnh).toFixed(2)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("更新日期：" + _vm._s(_vm.jjgk.gk[_vm.jjgk.gk.length - 1].time))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "echarts"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "charttitle"
  }, [_vm._v("累计净值走势图")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabindex === 1),
      expression: "tabindex===1"
    }],
    staticClass: "wapper"
  }, [(_vm.jjgk) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "i"
  }, [_vm._v("i")]), _vm._v("\n        " + _vm._s(_vm.jjgk.xx.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金名称：" + _vm._s(_vm.jjgk.xx.name))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金简称：" + _vm._s(_vm.jjgk.xx.jjjc))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金类型：" + _vm._s(_vm.jjgk.xx.jjlx))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金风格：" + _vm._s(_vm.jjgk.xx.jjfg))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("成立日期：" + _vm._s(_vm.jjgk.xx.clrq))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("管理机构：" + _vm._s(_vm.jjgk.xx.gljg))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("托管机构：" + _vm._s(_vm.jjgk.xx.tgjg))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("认购起点：" + _vm._s(_vm.jjgk.xx.rgqd))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("投资策略：" + _vm._s(_vm.jjgk.xx.tzcl))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("投资禁止：" + _vm._s(_vm.jjgk.xx.tzjz))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("投资范围：" + _vm._s(_vm.jjgk.xx.tzfw))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("基金特色：" + _vm._s(_vm.jjgk.xx.jjts))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabindex === 2),
      expression: "tabindex===2"
    }],
    staticClass: "wapper"
  }, [(_vm.jjgk) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "i"
  }, [_vm._v("i")]), _vm._v("\n        " + _vm._s(_vm.jjgk.xx.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.jjgk.jl.name))]), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_vm._v("任职时间：" + _vm._s(_vm.jjgk.jl.begin) + _vm._s((_vm.jjgk.jl.end === '') ? '至今' : '-' + _vm.jjgk.jl.end))]), _vm._v(" "), _c('div', {
    staticClass: "xq"
  }, [_vm._v(_vm._s(_vm.jjgk.jl.value))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f8c687d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/page/jjgk.vue
// module id = 803
// module chunks = 2